var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPlusCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 4.58325C8.41421 4.58325 8.75 4.91904 8.75 5.33325V10.6666C8.75 11.0808 8.41421 11.4166 8 11.4166C7.58579 11.4166 7.25 11.0808 7.25 10.6666V5.33325C7.25 4.91904 7.58579 4.58325 8 4.58325Z",
    className: "icon-fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5835 8C4.5835 7.58579 4.91928 7.25 5.3335 7.25H10.6668C11.081 7.25 11.4168 7.58579 11.4168 8C11.4168 8.41421 11.081 8.75 10.6668 8.75H5.3335C4.91928 8.75 4.5835 8.41421 4.5835 8Z",
    className: "icon-fill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1.75C4.54788 1.75 1.75 4.54788 1.75 8C1.75 11.4521 4.54788 14.25 8 14.25C11.4521 14.25 14.25 11.4521 14.25 8C14.25 4.54788 11.4521 1.75 8 1.75ZM0.25 8C0.25 3.71945 3.71945 0.25 8 0.25C12.2805 0.25 15.75 3.71945 15.75 8C15.75 12.2805 12.2805 15.75 8 15.75C3.71945 15.75 0.25 12.2805 0.25 8Z",
    className: "icon-fill"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlusCircle);
export default __webpack_public_path__ + "static/media/icon-plus-circle.3f09278986e7d593cfd8943d8bcba358.svg";
export { ForwardRef as ReactComponent };